// *******************************************************************************
// Form handling
// *******************************************************************************

const fileCountValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    if (input.element.files) {
      const { maxFiles, maxError, indexId } = input.element.dataset;
      const fileArray = filesToUpload[indexId];

      if (fileArray.length > maxFiles) {
        error = {
          valid: false,
          message: maxError,
        };
      }
    }

    return error;
  },
});

const fileSizeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    const {
      dataset: { fvName, maxSize, sizeError },
    } = input.element;

    const splitName = fvName.split('-');
    const indexId = splitName.at(-1);
    const fileIndex = splitName[0];

    const filesArray = filesToUpload[indexId];

    const validatedFile = filesArray.filter((item) => String(item?.id) === fileIndex);
    const { file } = validatedFile[0];

    if (file.size > maxSize) {
      error = {
        valid: false,
        message: sizeError,
      };
    }

    return error;
  },
});

const fileTypeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    const {
      dataset: { extensions, typeError, fvName },
    } = input.element;

    const types = extensions.split(',');

    const splitName = fvName.split('-');
    const indexId = splitName.at(-1);
    const fileIndex = splitName[0];

    const filesArray = filesToUpload[indexId];

    const validatedFile = filesArray.filter((item) => String(item?.id) === fileIndex);
    const { file } = validatedFile[0];

    const fileType = `.${file.name.split('.').pop()}`;

    if (!types.includes(fileType)) {
      error = {
        valid: false,
        message: typeError,
      };
    }

    return error;
  },
});

const handleForm = (form, formAction) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.upload-box'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .registerValidator('checkMaxFiles', fileCountValidator)
    .registerValidator('checkFilesSize', fileSizeValidator)
    .registerValidator('checkFilesType', fileTypeValidator)
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox, .upload-box');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      Object.keys(fv.fields).forEach((field) => {
        fv.revalidateField(field);
      });

      grecaptcha.ready(async () => {
        formParent.classList.add('show-loader');

        try {
          const files = {};
          let indexValue = 0;
          Object.keys(filesToUpload).forEach((index) => {
            const filesArray = filesToUpload[index];
            const inputValues = JSON.parse(getFormValue(form, fv).inputs);

            if (filesArray && filesArray.length > 0) {
              filesArray.forEach((file) => {
                const author = inputValues[`${file?.id}-photo-author-${index}`];
                const description = inputValues[`${file?.id}-photo-description-${index}`];

                files[`files_${indexValue}`] = {
                  file: file?.file,
                  description,
                  author: author || '',
                };

                indexValue += 1;
              });
            }
          });

          let requiredInputs = '';
          form.querySelectorAll('.form-component__inner input, .form-component__inner textarea').forEach((input) => {
            if (input.type !== 'hidden' && input.hasAttribute('required')) {
              requiredInputs += `${input.name}|`;
            }
          });
          requiredInputs = requiredInputs.slice(0, -1);

          let checkedCheckboxes = '';
          formParent.querySelectorAll('.checkbox-group .checkbox input').forEach((input) => {
            if (input.checked) {
              checkedCheckboxes += `${input.id}|`;
            }
          });
          checkedCheckboxes = checkedCheckboxes.slice(0, -1);

          await onFormSubmit({
            formData: {
              ...getFormValue(form, fv),
              ...files,
              id: localData.id,
              k: form.querySelector('[data-k]').value,
              lang: localData.lang,
              requiredInputs,
              checkedCheckboxes,
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: formAction,
          });

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');
          if (formParent.closest('.form-modal')) {
            const formModalEle = formParent.closest('.form-modal');
            formModalEle.classList.add('show-thankyou');
          }

          // Set Section In Visible Area
          const parentSection = formParent.closest('section');
          if (parentSection) {
            const topOffset = windowWidth() < breakpointSm ? 85 : windowWidth() < breakpointLg ? 112 : 165;
            const targetScrollPosition = window.scrollY + parentSection.getBoundingClientRect().top - topOffset;
            window.scrollTo({ top: targetScrollPosition, behavior: 'smooth' });
          }
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
      });
    });

  const removeFile = (removeButton, uploadButton, ele, item) => {
    const uploadBoxId = ele.getAttribute('data-upload-id');
    const filesArray = filesToUpload[uploadBoxId];
    const input = item.querySelector('input');
    const textarea = item.querySelector('textarea');
    const inputField = input?.getAttribute('name');
    const textareaField = textarea?.getAttribute('name');

    if (filesArray) {
      const fileId = Number(removeButton);
      const fileIndex = filesArray.findIndex((file) => file.id === fileId);
      filesArray.splice(fileIndex, 1);
      fv.validateField(uploadButton.getAttribute('name'));
    }

    if (input && inputField) {
      fv.removeField(inputField);
    }

    if (textarea && textareaField) {
      fv.removeField(textareaField);
    }
  };

  // Upload Box Dynamically Added Field Validation
  const uploadBox = form.querySelectorAll('.upload-box');
  uploadBox.forEach((ele, index) => {
    ele.setAttribute('data-upload-id', index);
    const uploadButton = ele.querySelector('.upload-box__input');

    const uploadName = uploadButton.getAttribute('name');
    if (uploadName) {
      fv.addField(uploadName, {
        validators: {
          checkMaxFiles: {
            message: '',
          },
        },
      });
    }

    uploadButton.addEventListener('change', () => {
      const inputWrapper = ele.querySelectorAll('.upload-box__list-text-wrapper li');
      fv.validateField(uploadButton.getAttribute('name'));

      // Check if inputWrapper is not empty before looping through it
      if (inputWrapper.length > 0) {
        inputWrapper.forEach((item) => {
          const removeButton = item.querySelector('.upload-box__list-remove');
          const input = item.querySelector('input');
          const textarea = item.querySelector('textarea');
          const inputField = input?.getAttribute('name');
          const textareaField = textarea?.getAttribute('name');

          if (input) {
            fv.addField(inputField, {
              validators: {
                checkFilesSize: {
                  message: '',
                },
                checkFilesType: {
                  message: '',
                },
              },
            });

            input.addEventListener('keyup', () => {
              fv.validateField(inputField);
            });
          }

          if (textarea) {
            fv.addField(textareaField, {
              ...(!input && {
                validators: {
                  checkFilesSize: {
                    message: '',
                  },
                  checkFilesType: {
                    message: '',
                  },
                },
              }),
            });

            textarea.addEventListener('keyup', () => {
              fv.validateField(textareaField);
            });
          }

          removeButton.addEventListener('click', () => {
            removeFile(removeButton?.id, uploadButton, ele, item);
          });
        });
      }
    });
  });

  // Reset Form
  attachEvent('.form-component__success .btn', 'click', (ev) => {
    ev.preventDefault();
    const parentEle = ev.target.closest('.form-component');
    parentEle?.classList.remove('show-thankyou');

    const form = parentEle.querySelector('form');
    if (form) {
      form.reset();
      const uploadBoxInputs = parentEle.querySelectorAll('.upload-box__input');
      uploadBoxInputs.forEach((inputEle) => {
        const parentElem = inputEle.closest('.upload-box');
        const selectedList = parentElem.querySelector('.upload-box__list-text-wrapper');
        const ulElement = selectedList.querySelector('ul');
        ulElement.innerHTML = '';
      });
    }

    const allHiddenInput = parentEle.querySelectorAll('.checkbox-group__hidden-inputs');
    allHiddenInput.forEach((ele) => {
      ele.classList.add('hide');
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  ['form-module'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
});

// Check if all checkboxes in group have same name
document.querySelectorAll('.checkbox-group').forEach((checkboxGroup) => {
  const checkboxes = checkboxGroup.querySelectorAll('input[type="checkbox"]');

  if (checkboxes.length > 1) {
    const uniqueNames = new Set([...checkboxes].map((checkbox) => checkbox.name));
    const isCheckboxGroup = uniqueNames.size === 1;

    checkboxGroup.classList.toggle('checkbox-group', isCheckboxGroup);

    // Check if failed
    const observer = new MutationObserver(() => {
      const checkboxParents = checkboxGroup.querySelectorAll('.checkbox');
      const hasFailedCheckbox = [...checkboxParents].some((checkboxParent) =>
        checkboxParent.classList.contains('is-validation-failed'),
      );
      checkboxGroup.classList.toggle('failed', hasFailedCheckbox);
    });
    checkboxes.forEach((checkbox) =>
      observer.observe(checkbox.closest('.checkbox'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div

    const errorMessage = checkboxGroup.querySelector('[data-fv-not-empty___message]');
    if (errorMessage) {
      const groupErrorMessage = document.createElement('div');
      groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
      groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

      checkboxGroup.appendChild(groupErrorMessage);
    }
  }
});
